<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="m-container m-pt-40">
    <PageHeader
      icon="questionCircle"
      title="Zistenia & dobré rady"
      lead="Tu je priestor pre zápis dohody medzi vami a druhou stranou (priehradový zamestnanec, vedúci pošty atď.). Máte dve možnosti, buď si zapíšete hlavné body dohody do 'Popisu' alebo si len jednoducho odfotíte vaše poznámky a vložíte túto fotografiu."
      border
    />
    <FormSheet>
      <FormGroup label="Popis">
        <InputTextarea
          v-model="activity.agreement.description"
        />
      </FormGroup>
      <AttachmentUploader
        :attachments="activity.agreement.attachments"
      />
    </FormSheet>
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader.vue';
import FormSheet from '@/components/FormSheet.vue';
import FormGroup from '@/components/FormGroup.vue';
import InputTextarea from '@/components/InputTextarea.vue';
import AttachmentUploader from '@/components/AttachmentUploader.vue';

defineProps({
  activity: {
    type: Object,
    required: true,
  },
});
</script>
